import{INPUT_MANAGEMENT_NOM_WEEK_MODEL_LIST, INPUT_MANAGEMENT_NOM_WEEK_SEARCH, INPUT_MANAGEMENT_NOM_WEEK_PAGINATION,INPUT_MANAGEMENT_NOM_WEEK_DROP_DOWN_SEARCH_TYPE}from './actionType'

export const setModelDeviceListToState = (payload) => ({
    type: INPUT_MANAGEMENT_NOM_WEEK_MODEL_LIST,
    payload
})

export const setSearchToState = (payload) => ({
    type: INPUT_MANAGEMENT_NOM_WEEK_SEARCH,
    payload
})
export const setPaginationToState = (payload) => ({
    type: INPUT_MANAGEMENT_NOM_WEEK_PAGINATION,
    payload
})
export const setDropDownSearchType = (payload) => ({
    type: INPUT_MANAGEMENT_NOM_WEEK_DROP_DOWN_SEARCH_TYPE,
    payload
})